import "./styles/custom-antd.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import App from "./App";
import { AuthProvider } from "./Contexts/AuthContext";
import { AuthModalProvider } from "./Contexts/AuthModalContext";
import CartContext from "./Contexts/CartContext";
import { ConfigProvider } from "./Contexts/ConfigContext";
import { QUERY_CACHE_BUSTER, QUERY_CACHE_MAX_AGE, queryClient, queryPersister } from "./config/queryClient";
import "./index.css";
import "./styles/app.scss";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import ReactGA from "react-ga4";


const root = ReactDOM.createRoot(document.getElementById("root"));

// ReactGA.initialize("G-YP4V199P8C");

root.render(
    <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister: queryPersister, maxAge: QUERY_CACHE_MAX_AGE, buster: QUERY_CACHE_BUSTER }}
    >
        <CartContext>
            <ConfigProvider>
                <AuthProvider>
                    <AuthModalProvider>
                        <App />
                    </AuthModalProvider>
                </AuthProvider>
            </ConfigProvider>
        </CartContext>
    </PersistQueryClientProvider>
);

// const SendAnalytics = ()=> {
//   ReactGA.send({
//     hitType: "pageview",
//     page: window.location.pathname,
//   });
// }

// reportWebVitals(SendAnalytics);